
































import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import BasicComponent from "@/global/BasicComponent";
import {OrderConfirmationDto} from "@swagger";

/*
 * Depcrecated in favor of stripe elements
 */
@Component({
  components: {}
})
export default class CardPayment extends BasicComponent {

  @Prop(Boolean) formDataValid!: boolean;
  @Prop(Object) shippingData!: object;
  @Prop(String) email!: string;
  @Prop(String) clientSecret!: string;
  @Prop(Object) stripe: object;
  @Prop(Boolean) active: boolean;

  holderFirstName: string = "";
  holderLastName: string = "";
  elements: any = null;
  card: any = null;
  detailsValid: boolean = false;
  error: string | null = null;

  mounted() {
    this.elements = this.stripe["elements"]();
    this.card = this["elements"].create('card', {
      hidePostalCode: true
    });
    const eventHandler = this.onCardDetailsChange;
    this.card.on("change", (event) => {
      eventHandler(event);
    });
    this.card.mount(this.$refs.card);
  }

  onCardDetailsChange(event) {
    console.log(this.card);
    console.log(event);
    if (event.error) {
      this.error = event.error.message;
    } else {
      this.error = null;
    }
    console.error(this.error);
    this.$emit("on-card-error", this.error)

    this.detailsValid = event.complete && !event.error;
  }

  chargePayment(order: OrderConfirmationDto) {
    var clientSecret = this.clientSecret;

    const setError = (error) => {
      this.$emit("on-error", error);
    };

    const onSuccess = (paymentIntent) => {
      this.$emit("on-success", order.orderId, order.orderToken, paymentIntent);
    };

    this.stripe["handleCardPayment"](
        clientSecret, this.card, {
          payment_method_data: {
            billing_details: {
              name: `${this.holderFirstName} ${this.holderLastName}`
            }
          }
        }
    ).then(function (result) {
      if (result.error) {
        setError(result.error.message);
      } else {
        onSuccess(result.paymentIntent.id);
      }
    });
  }

  get isDetailsValid() {
    return this.detailsValid;
  }

  get getError() {
    return this.error;
  }

}

